var _path, _path2, _path3, _path4, _g, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _circle, _circle2, _circle3, _circle4, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinionNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 478,
    viewBox: "0 0 372 478",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.185 396.632L171.279 385.107L207.399 388.628L204.585 404.86C210.697 414.531 212.802 431.777 206.933 436.379C201.065 440.98 174.748 435.459 168.319 430.644C161.89 425.829 160.281 418.584 161.436 410.263C162.253 404.38 168.185 396.632 168.185 396.632Z",
    fill: "#232631"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0303 373.003L84.8393 352.852L118.896 362.374C118.896 362.374 119.839 367.754 120.747 371.129C122.588 377.972 128.21 384.797 127.367 388.024C126.525 391.252 116.309 393.411 107.862 396.721C99.4145 400.031 90.7691 410.471 77.6076 412.262C67.2025 413.678 53.0246 411.36 50.9484 408.75C48.8722 406.14 49.6317 395.308 50.4742 392.081C51.3166 388.854 67.2445 376.046 83.0303 373.003Z",
    fill: "#232631"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.316 34.6813C100.889 60.4931 62.2279 261.701 62.2279 261.701L60.2546 292.059L91.1336 326.605L241.897 374.805L263.166 364.991L270.668 348.553C257.636 328.066 367.496 172.221 328.333 93.7524C308.319 53.6534 226.054 19.9681 177.316 34.6813Z",
    fill: "#FDDB44"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_543_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 31,
    width: 278,
    height: 344
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.316 34.6813C100.889 60.4931 62.2279 261.701 62.2279 261.701L60.2546 292.059L91.1336 326.605L241.897 374.805L267.488 366.151L273.747 337.018C260.715 316.53 367.496 172.221 328.333 93.7524C308.319 53.6534 226.054 19.9681 177.316 34.6813Z",
    fill: "#FDDB44"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_543_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.364 72.5485C279.564 45.0716 247.031 22.4374 247.031 22.4374L293.835 14.9267L346.31 118.59L311.035 295.99L263.166 364.991L201.424 399.378L54.7017 347.63L35.1063 288.315L84.6014 167.242C84.6014 167.242 84.7357 201.255 104.13 209.55C123.524 217.846 201.38 255.738 219.267 246.641C237.153 237.544 277.164 100.025 278.364 72.5485Z",
    fill: "#FCB537"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9715 189.904C78.3795 186.813 81.7865 183.475 81.7865 183.475L79.8526 190.678C79.0791 193.559 92.0045 220.195 95.1659 225.677C98.3272 231.159 214.131 271.518 226.042 273.171C237.953 274.825 295.895 271.849 295.895 271.849L299.656 263.592C299.656 263.592 301.806 267.67 302.43 270.515C304.179 278.48 298.843 289.629 297.016 290.683L289.706 294.898C289.706 294.898 237.914 297.98 230.885 306.904C223.856 315.827 218.721 340.703 221.776 352.334C224.831 363.965 265.56 361.001 263.165 364.991C260.77 368.981 234.252 390.808 213.828 393.443C186.631 396.951 160.681 389.759 128.729 376.772C99.207 364.773 83.1248 356.806 71.707 347.563C60.2892 338.32 57.2344 326.689 57.1673 309.683C57.1002 292.676 77.0664 247.072 77.0664 247.072C77.0664 247.072 68.007 227.783 68.9558 214.007C69.5962 204.709 73.2103 198.161 76.9715 189.904Z",
    fill: "#27456A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9416 242.403C99.6613 237.695 94.499 222.409 94.499 222.409L233.632 273.665C233.632 273.665 214.412 276.226 208.93 279.387C203.448 282.549 185.83 359.671 179.961 364.273C174.092 368.875 156.139 360.966 132.036 352.95C111.23 346.03 78.456 333.931 74.3475 320.473C70.2389 307.015 100.222 247.112 99.9416 242.403Z",
    fill: "url(#paint0_linear_543_2)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.653,
    cy: 111.049,
    rx: 41.7638,
    ry: 44.7671,
    transform: "rotate(15.0289 150.653 111.049)",
    fill: "#CBBED8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.305,
    cy: 116.729,
    rx: 35.7975,
    ry: 37.2891,
    transform: "rotate(15.0289 155.305 116.729)",
    fill: "#FDFEF9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.405,
    cy: 143.203,
    rx: 43.2553,
    ry: 46.2384,
    transform: "rotate(15.0289 242.405 143.203)",
    fill: "#CBBED8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.18,
    cy: 150.125,
    rx: 38.7806,
    ry: 40.2722,
    transform: "rotate(15.0289 245.18 150.125)",
    fill: "#FDFEF9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.8,
    cy: 118.943,
    r: 23.865,
    transform: "rotate(15.0289 157.8 118.943)",
    fill: "#0D071D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.805,
    cy: 147.138,
    r: 23.865,
    transform: "rotate(15.0289 239.805 147.138)",
    fill: "#0D071D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.132,
    cy: 105.871,
    r: 5.96625,
    transform: "rotate(15.0289 155.132 105.871)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.483,
    cy: 136.174,
    r: 5.96625,
    transform: "rotate(15.0289 233.483 136.174)",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.706 130.467C150.858 129.158 148.549 123.902 147.346 120.066C146.673 117.924 144.316 116.634 142.232 117.469C140.585 118.129 139.69 119.901 140.274 121.577C141.968 126.438 146.036 135.776 152.772 137.67C159.946 139.686 168.162 132.738 171.039 130.011C171.708 129.377 171.915 128.415 171.62 127.541C171.038 125.817 168.836 125.231 167.368 126.306C164.083 128.712 158.753 131.844 154.706 130.467Z",
    fill: "url(#paint1_linear_543_2)",
    stroke: "black",
    strokeWidth: 2.50723
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M236.324 160.102C232.556 158.82 230.123 154.28 228.787 150.884C227.985 148.845 225.673 147.659 223.639 148.475C221.912 149.167 221.015 151.061 221.73 152.778C223.618 157.316 227.841 165.464 234.39 167.305C241.434 169.285 249.239 163.531 252.151 161.082C252.891 160.459 253.133 159.451 252.824 158.535L252.764 158.357C252.205 156.702 250.139 156.076 248.655 156.999C245.479 158.975 240.347 161.471 236.324 160.102Z",
    fill: "url(#paint2_linear_543_2)",
    stroke: "black",
    strokeWidth: 2.50723
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.063 196.839C168.353 220.514 185.331 225.251 220.853 217.724",
    stroke: "black",
    strokeWidth: 2.50723,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.242 164.145C157.726 186.101 120.005 179.682 105.301 141.912C143.619 165.552 160.628 162.339 187.065 142.244C187.065 142.244 198.897 190.208 235.017 193.728C271.137 197.249 280.593 173.533 280.593 173.533L294.999 177.401C294.999 177.401 294.594 180.375 276.557 197.929C258.52 215.482 206.878 210.108 185.242 164.145Z",
    fill: "#F9A831"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M322.41 161.594L296.026 139.066L278.38 176.027L308.138 191.739L322.41 161.594Z",
    fill: "#13152C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.776 62.173C188.77 68.8836 203.813 95.9565 196.51 123.158C189.206 150.36 162.626 166.257 137.632 159.547C112.639 152.836 97.5955 125.763 104.899 98.5615C112.202 71.3599 138.782 55.4625 163.776 62.173Z",
    stroke: "url(#paint3_linear_543_2)",
    strokeWidth: 12.5361
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M255.864 93.0756C281.806 100.041 297.299 127.405 290.038 154.448C282.778 181.49 255.662 197.414 229.72 190.449C203.778 183.484 188.286 156.119 195.546 129.077C202.807 102.035 229.922 86.1105 255.864 93.0756Z",
    stroke: "url(#paint4_linear_543_2)",
    strokeWidth: 12.5361
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M353.288 196.139C357.053 183.124 360.357 164.061 347.392 160.58C334.427 157.099 333.934 164.688 333.934 164.688L317.729 202.036C317.729 202.036 323.171 222.03 330.761 222.523C338.35 223.016 349.67 208.651 353.288 196.139Z",
    fill: "#FAFBF6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M334.534 150.95C345.083 154.149 348.833 160.966 348.833 160.966C348.833 160.966 336.042 168.343 329.187 188.124C320.395 213.492 330.762 222.523 330.762 222.523C330.762 222.523 325.009 223.461 321.345 223.084C315.522 222.484 307.326 217.775 307.326 217.775C307.326 217.775 297.349 208.919 309.793 179.828C322.237 150.737 334.534 150.95 334.534 150.95Z",
    fill: "#252644"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M270.341 326.763C270.341 326.763 252.601 306.556 255.202 302.621C257.803 298.687 278.85 295.071 283.172 296.232C287.494 297.392 296.271 333.725 293.95 342.368L293.95 342.369C291.63 351.012 291.243 352.452 285.761 355.614C280.279 358.775 232.141 359.75 232.141 359.75L234.115 329.392L270.341 326.763Z",
    fill: "#FDDB44"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2075 238.152C28.9122 246.412 62.81 258.299 64.694 255.547C66.578 252.794 67.8853 236.714 65.713 232.802C63.5408 228.89 43.5481 229.755 43.5481 229.755L46.5919 222.946L20.5182 206.715C20.5182 206.715 9.50278 229.892 19.2075 238.152Z",
    fill: "#FDDB44"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M248.026 340.848C247.466 331.432 241.143 320.468 236.435 320.748C231.727 321.028 229.773 323.418 229.773 323.418C229.773 323.418 226.351 318.041 213 316C199.648 313.96 184.362 319.122 184.362 319.122C178.096 325.952 177.122 329.883 182.602 337.182C180.99 341.773 180.883 344.5 185.27 350.254C184.492 357.978 186.08 359.887 189.765 362.271C189.765 362.271 210.426 360.096 213.694 359.43C216.962 358.763 222.057 357.042 222.057 357.042C222.057 357.042 233.195 361.577 236.463 360.91C239.731 360.242 248.587 350.265 248.026 340.848Z",
    fill: "#2A2B47"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M118.288 258.582L180.01 279.488C183.239 280.582 185.002 284.057 183.977 287.309L171.605 326.57C170.549 329.922 166.945 331.75 163.616 330.623L101.895 309.717C98.6656 308.624 96.9026 305.148 97.9274 301.896L110.3 262.635C111.356 259.284 114.96 257.455 118.288 258.582Z",
    fill: "url(#paint5_radial_543_2)",
    stroke: "#2D3F66",
    strokeWidth: 7.52169
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M102.519 332.322L92.6369 328.765C90.8184 328.111 89.8051 326.172 90.3063 324.305C90.87 322.206 93.1079 321.036 95.1535 321.772L105.036 325.329C106.855 325.983 107.868 327.922 107.367 329.789C106.803 331.889 104.565 333.058 102.519 332.322Z",
    fill: "#2B3956"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M127.901 342.353L117.911 339.111C116.072 338.514 114.998 336.608 115.44 334.727C115.937 332.61 118.137 331.37 120.205 332.042L130.195 335.283C132.033 335.88 133.107 337.786 132.665 339.667C132.168 341.784 129.969 343.024 127.901 342.353Z",
    fill: "#2B3956"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M157.18 350.47L146.982 347.956C145.105 347.493 143.897 345.669 144.202 343.761C144.545 341.614 146.65 340.22 148.761 340.74L158.959 343.254C160.835 343.717 162.044 345.541 161.738 347.449C161.395 349.596 159.29 350.991 157.18 350.47Z",
    fill: "#2B3956"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.043 192.315C339.817 189.434 347.339 172.921 351.661 174.081C355.982 175.241 352.115 189.647 350.954 193.968C349.794 198.29 344.486 212.309 338.723 210.761C333.691 209.41 337.103 198.545 338.563 193.896C338.775 193.222 338.945 192.679 339.043 192.315Z",
    fill: "#2F3451"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.924 144.631L83.294 200.868L77.6384 193.172L99.9883 132.226L105.924 144.631Z",
    fill: "#FFEEA1",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.701 220.763L289.361 273.183L295.896 271.849L318.463 222.31L312.701 220.763Z",
    fill: "#FFEEA1",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M246.373 352.76L241.558 359.189L271.249 357.895C271.18 359.038 283.937 356.13 287.588 354.56C291.24 352.99 294.637 341.325 294.724 339.487C293.033 322.505 290.939 313.107 284.612 296.618L278.463 296.512C278.463 296.512 292.23 337.273 291.456 340.154C290.682 343.035 289.135 348.798 286.921 351.292C284.707 353.786 246.373 352.76 246.373 352.76Z",
    fill: "#FFFF95"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9863 395.367C63.7374 397.681 60.1865 397.352 55.1593 392.614C55.9504 388.416 57.7925 386.032 63.5238 381.699C65.8518 383.507 68.6927 384.285 76.4322 385.069C76.2775 389.1 74.8812 391.354 70.9863 395.367Z",
    fill: "#636E8A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5049 395.68C68.9179 403.451 69.7338 407.058 74.3571 411.424C89.1347 409.662 97.2054 406.903 111.066 397.567C119.828 395.025 124.381 393.447 129.112 389.179C128.052 381.93 126.92 378.064 121.032 372.593C112.004 375.578 106.795 376.278 97.0662 374.609C88.9004 380.084 83.7907 382.814 72.0322 385.999C72.5674 389.998 72.2355 392.149 69.5049 395.68Z",
    fill: "#333F59"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M172.293 410.089C168.748 405.89 168.184 396.631 168.184 396.631C168.184 396.631 164.049 401.957 162.596 405.941C160.987 410.353 160.131 413.227 160.942 417.852C162.012 423.951 163.588 430.523 169.759 431.03C176.94 431.62 178.722 414.904 178.722 414.904C178.722 414.904 174.316 412.486 172.293 410.089Z",
    fill: "#333F59"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M190.913 421.267C185.758 419.764 177.424 420.116 178.722 414.905C179.167 413.117 179.889 412.126 181.323 410.97C185.429 407.659 188.637 415.555 193.901 415.891C197.031 416.091 198.842 414.154 201.877 414.944C205.659 415.929 208.189 417.859 209.36 421.587C211.52 428.46 197.831 423.283 190.913 421.267Z",
    fill: "#636E8A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7165 12.6325C58.6497 12.6344 57.6637 12.7743 55.8437 13.352C52.0852 14.545 50.9473 19.5431 45.8679 38.8501C42.0423 53.3913 45.0845 69.8888 46.6469 74.5657C48.0485 78.7616 51.4352 81.7208 72.4246 96.5455C83.8281 104.6 86.9477 113.186 88.5618 119.486C90.764 128.082 86.5466 133.399 74.0345 150.144C59.2856 169.883 51.2006 175.467 48.9019 183.844C43.2647 204.388 47.7423 213.112 51.5594 223.14C56.0099 234.832 64.3914 245.243 70.2289 252.656C73.9178 258.412 76.6898 266.082 79.1163 275.994C80.0909 280.745 80.5444 284.927 79.9026 290.056",
    stroke: "white",
    strokeWidth: 1.4464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2012 189.124C22.0686 191.748 17.7706 203.746 21.7072 212.944C25.6438 222.143 33.2626 224.687 33.2626 224.687C39.9153 226.133 43.5996 226.106 49.9061 221.192C53.642 221.768 71.1021 221.554 73.9943 218.139C76.8865 214.725 74.689 206.935 72.9498 205.526C71.2106 204.117 77.9444 201.938 76.4581 196.769C74.9718 191.601 69.6293 190.985 69.6293 190.985C70.7873 184.736 70.7361 182.519 65.3443 177.582C65.3443 177.582 54.8336 178.452 47.5627 180.113C40.2919 181.773 34.3337 186.499 28.2012 189.124Z",
    fill: "#2A2B47"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_543_2",
    x1: 165.806,
    y1: 241.554,
    x2: 135.099,
    y2: 355.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFBCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53657D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_543_2",
    x1: 171.132,
    y1: 132.561,
    x2: 138,
    y2: 123.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#2778DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C0522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_543_2",
    x1: 252.364,
    y1: 163.637,
    x2: 219.231,
    y2: 154.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#2778DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C0522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_543_2",
    x1: 165.402,
    y1: 56.1189,
    x2: 136.007,
    y2: 165.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#323D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_543_2",
    x1: 257.49,
    y1: 87.0215,
    x2: 228.095,
    y2: 196.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#323D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_543_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.953 294.603) rotate(104.698) scale(33.5602 44.0011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111022"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinionNormal);
export default __webpack_public_path__ + "static/media/minion-normal.bf43e0b63a28739cfc5fe69791aa505a.svg";
export { ForwardRef as ReactComponent };